module.exports = __webpack_public_path__ + "img/icon-expense.1550df08.svg";